import { Spinner } from "@heroui/spinner";

export default function Loader() {
  return (
    <div className="h-screen w-screen flex justify-center items-center bg-background/30 backdrop-blur-sm">
      <Spinner color="primary" label="Loading..." />
    </div>
  );
}
